import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from './LocalizedLink';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.contact.title')}</h3>
            <p className="mb-2">
              <span className="font-bold text-yellow-500">{t('footer.contact.phone')}:</span>{' '}
              <a href="tel:+34600238283" className="hover:text-yellow-500 transition-colors">+34 600 23 82 83</a>
            </p>
            <p>
              <span className="font-bold text-yellow-500">{t('footer.contact.email')}:</span>{' '}
              <a href="mailto:info@electricista-urgencias-24-horas-barcelona.com" className="hover:text-yellow-500 transition-colors">
                info@electricista-urgencias-24-horas-barcelona.com
              </a>
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.hours.title')}</h3>
            <p className="font-bold text-yellow-500">{t('footer.hours.24hours')}</p>
            <p className="font-bold text-yellow-500">{t('footer.hours.7days')}</p>
            <p className="font-bold text-yellow-500">{t('footer.hours.365days')}</p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.license.title')}</h3>
            <p>{t('footer.license.licensed')}</p>
            <p>{t('footer.license.registration')}: EL-2023-BCN</p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-wrap gap-4 order-2 md:order-1">
              <Link 
                to="/privacy-policy" 
                onClick={handleLinkClick}
                className="text-gray-400 hover:text-yellow-500 transition-colors"
              >
                Política de Privacidad
              </Link>
              <Link 
                to="/terms" 
                onClick={handleLinkClick}
                className="text-gray-400 hover:text-yellow-500 transition-colors"
              >
                Términos y Condiciones
              </Link>
              <Link 
                to="/security" 
                onClick={handleLinkClick}
                className="text-gray-400 hover:text-yellow-500 transition-colors"
              >
                Seguridad
              </Link>
            </div>
            <p className="order-1 md:order-2">{t('footer.copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;